'use client'

import React, { useEffect } from 'react'
import { Spin } from 'antd';

import { PageHeaderWrapper } from '../../../wrapperComponents/page';
import formatMsg from '../../../../util/formatMsg';
import styles from './style.module.css'
import { Helper, timeutil } from "sharedresources";


const MobileCalendarSingleScheduleView = (props: any) => {

    const {
        selectedSchedule,
        drawerOnClose,
        isLoading,
        scheduleDetail,
        firebase,
        getParticipantsChildren,
        participantAttendanceStats
    } = props;

    useEffect(() => {
        return () => {
            drawerOnClose();
        }
    }, []);

    function getAttendanceStats() {

        return (
            <div className={styles.headerSubText}>
                {(participantAttendanceStats?.present || 0) + ' Present'}
                <span className={styles.dot} />
                {(participantAttendanceStats?.absent || 0) + ' Absent'}
                <span className={styles.dot} />
                {(participantAttendanceStats?.pending || 0) + ' Pending'}
            </div>
        )
    }

    function getBookingStats() {

        return (
            <div className={`${styles.headerSubText} ${styles.mtBottom}`}>
                {(props.scheduleDetail?.waitlists?.length || 0) + ' Waitlisted'}
                <span className={styles.dot} />
                {(props.scheduleDetail?.confirmationPendings?.length || 0) + ' Confirmation Pending'}
            </div>
        )
    }

    return (
        <Spin spinning={isLoading}>
            <PageHeaderWrapper>
                <div className="global-page-header">
                    {formatMsg('sessionDetails')}
                </div>
            </PageHeaderWrapper>

            <div className={styles.viewAlign}>

                <div className={styles.packageDetails}>
                    <div
                        className={styles.packageCircle}
                        style={{ backgroundColor: selectedSchedule?.color?.darkColor || '' }}
                    />
                    <div className={styles.packageName}>
                        {selectedSchedule?.packageName}
                    </div>
                </div>

                <div className={styles.basicDetails}>
                    <div className={styles.displayFlex}>
                        <img
                            src='/images/calendarV2.png'
                            className={styles.scheduleImg}
                        />
                        <p
                            className={styles.drawerScheduleDetail}
                        >
                            {timeutil.getInstance(selectedSchedule?.date).format('dddd, DD MMMM YYYY')}
                        </p>
                    </div>
                    {props.selectedSchedule?.activityName && <div className={styles.displayFlex}>
                        <img src='/images/activityIcon.png' className={styles.scheduleImg} />
                        <p className={styles.drawerScheduleDetail}>{props.selectedSchedule?.activityName}</p>
                    </div>}
                    <div className={styles.displayFlex}>
                        <img
                            src='/images/clockV2.png'
                            className={styles.clockImg}
                        />
                        <p
                            className={styles.drawerScheduleDetail}
                        >
                            {timeutil.getInstance(selectedSchedule?.startTime).format('hh:mma') + " - " + timeutil.getInstance(selectedSchedule?.endTime).format('hh:mma')}
                        </p>
                    </div>
                    <div className={styles.displayFlex}>
                        <img src='/images/batchV2.png' style={{ height: 15, width: 15, marginRight: 12 }} />
                        <p
                            className={styles.drawerScheduleDetail}
                        >
                            {selectedSchedule?.batchName}
                        </p>
                    </div>
                    {/* {
                        (selectedSchedule?.instructors?.length > 0) &&
                        <div className={styles.instructorsContainer}>
                            <img src='/images/board.png' style={{ height: 15, width: 16, marginRight: 12 }} />
                            <p
                                className={styles.drawerScheduleDetail}
                            >
                                {selectedSchedule?.instructors?.map(s => s.name).join(", ")}
                            </p>
                        </div>
                    } */}
                </div>

                <div className={styles.horizontalDivider} />

                {/* <div className={styles.scheduleDataContainer}>
                    <div className={styles.generalFlexRow}>
                        <div className={styles.general1stCol}>
                            <div className={styles.flexImgContainer}>
                                <img src='/images/confirm.png' style={{ height: 16, width: 16 }} />
                            </div>
                            <div>
                                {"Confirmed Bookings"}:
                            </div>
                        </div>
                        <div>
                            {(scheduleDetail?.totalBookings?.length || 0) + " " + "seats"}
                        </div>
                    </div>
                    <div className={styles.generalFlexRow}>
                        <div className={styles.general1stCol}>
                            <div className={styles.flexImgContainer}>
                                <img src='/images/waitlisted.png' style={{ height: 15, width: 15 }} />
                            </div>
                            <div>
                                {formatMsg("waitlists")}:
                            </div>
                        </div>
                        <div>
                            {scheduleDetail?.waitlists?.length || "-"}
                        </div>
                    </div>
                    <div className={styles.generalFlexRow}>
                        <div className={styles.general1stCol}>
                            <div className={styles.flexImgContainer}>
                                <img src='/images/waitlisted.png' style={{ height: 15, width: 15 }} />
                            </div>
                            <div>
                                {"Confirmation Pending"}:
                            </div>
                        </div>
                        <div>
                            {scheduleDetail?.confirmationPendings?.length || "-"}
                        </div>
                    </div>
                    <div className={styles.generalFlexRow}>
                        <div className={styles.general1stCol}>
                            <div className={styles.flexImgContainer}>
                                <img src='/images/accountV2.png' style={{ height: 16, width: 14 }} />
                            </div>
                            <div>
                                {formatMsg("accountHolder")}:
                            </div>
                        </div>
                        <div>
                            {firebase && firebase?.user?.name || "-"}
                        </div>
                    </div>
                </div> */}

                <div className={styles.horizontalDivider} />

                <div>
                    <div className={styles.drawerHeading}>
                        <div>
                            <img
                                src='/images/twoUsers.png'
                                className={styles.twoUsersImg}
                            />
                        </div>
                        <div className={styles.headerText}>
                            <div>
                                {props.scheduleDetail?.students?.length || 0}
                            </div>
                            <div>
                                {
                                    (firebase?.schoolConfig?.useUserTypeAsDisplayName && firebase?.schoolConfig?.selectedUserTypeName)
                                        ? firebase?.schoolConfig?.selectedUserTypeName
                                        : formatMsg('users')
                                }
                            </div>
                        </div>
                    </div>
                    {getAttendanceStats()}
                    {getBookingStats()}
                </div>

                {(scheduleDetail?.students?.length)
                    ? getParticipantsChildren()
                    : <div className={styles.noParticipantsCont}>
                        <img
                            src="/images/noParticipantsV2.png"
                            className={styles.noParticipantsImg}
                        />
                        <div className={styles.noParticipantsText}>
                            {Helper.getSelectedUserTypeName(firebase, formatMsg("noParticipants"), formatMsg('no'), null, "LOWERCASE")}
                        </div>
                    </div>
                }
            </div>
        </Spin>
    )
}

export default MobileCalendarSingleScheduleView